// A page opened before a deploy still carries the OLD Server Action ids. Once
// Vercel Skew Protection's window passes (7 days, set 2026-09-24) the new
// deployment answers 404 and Next throws UnrecognizedActionError — the only
// cure is a full reload. Shared by every app's error page, the stale-page
// banner, and CluckUp's snap screens (app/cu/_lib/snap-failure.ts).
//
// Client-only: next/navigation's react-server build throws if this is called
// on the server.

import { unstable_isUnrecognizedActionError } from "next/navigation";

/** Plain boolean, NOT a type predicate: UnrecognizedActionError is structurally
 *  an Error, so a predicate narrows the false branch of an `Error` to `never`. */
export function isStaleDeployError(err: unknown): boolean {
  return unstable_isUnrecognizedActionError(err);
}

export const APP_UPDATED_TITLE = "New update ready";
export const APP_UPDATED_MESSAGE = "The app has a new update. Tap Reload, then try again.";
